import { createContext, useContext, useEffect } from 'react';

import { useRGetProfile, ProfileResponse } from '@repositories/common';
import { useLocation } from 'react-router-dom';

import { ProfileProviderProps } from './types';
import { isPublicUrl } from '@utils/isPublicUrl';

const ProfileContext = createContext<{
  data: ProfileResponse | undefined;
  isLoading: boolean;
  isError: boolean;
}>({ data: undefined, isLoading: false, isError: false });

function ProfileProvider(props: ProfileProviderProps) {
  const { children } = props;
  const { pathname } = useLocation();

  const isPublic = isPublicUrl(pathname);

  const { data, refetch, isLoading, isError } = useRGetProfile({
    enabled: !isPublic,
  });

  useEffect(() => {
    if (!isPublic) {
      refetch();
    }
  }, [isPublic, pathname, refetch]);

  return (
    <ProfileContext.Provider value={{ data: data?.data, isLoading, isError }}>
      {children}
    </ProfileContext.Provider>
  );
}

function useProfile() {
  return useContext(ProfileContext);
}

export { useProfile, ProfileProvider };
